import { createFileRoute } from "@tanstack/react-router";

import { AuditLogPage } from "@/components/audit/AuditLogPage";
import { requireFeature } from "@/lib/feature-gate";

export const Route = createFileRoute("/user/_layout/my-activity")({
  beforeLoad: () => requireFeature("audit"),
  component: () => <AuditLogPage scope="mine" />,
});
